import { maprange } from "../functions/maprange";

export function drawBar(canvas,barNodes, scale, width, heigth, distributedMagnitudeX, distributedMagnitudeY) {

    var ctx = canvas.getContext('2d')
    
    /************************************************************************
        O vetor que contem o nó nas barras, barNodes, guarda as barras como:
        [0] = coord x nó 1
        [1] = coord y nó 1
        [2] = índice do nó 1
        [3] = coord x nó 2
        [4] = coord y nó 2
        [5] = índice do nó 2
    *************************************************************************/
    for (var i = 0; i < barNodes.length; i++){
        const xbar1 = maprange(barNodes[i][0], 0, scale, 0, width)
        const ybar1 = maprange(barNodes[i][1], 0, (heigth/width)*scale, 0, heigth)
        const xbar2 = maprange(barNodes[i][3], 0, scale, 0, width)
        const ybar2 = maprange(barNodes[i][4], 0, (heigth/width)*scale, 0, heigth)
        ctx.strokeStyle = '#91908c'
        if(distributedMagnitudeX[i] !== 0 || distributedMagnitudeY[i] !== 0){
            ctx.strokeStyle = '#1409e0'
        }
        //console.log(canvas)
        ctx.beginPath();
        ctx.lineWidth = 4
        ctx.moveTo(xbar1,(heigth - ybar1));
        ctx.lineTo(xbar2, (heigth - ybar2));
        //estão invertidos por causa o flagPoint
        ctx.stroke();
        //renderizando dados da barra
        var posx = (xbar1 + (xbar2-xbar1)/2)-50
        var posy = heigth - (ybar1 - (ybar1-ybar2)/2)
        if(xbar1 === xbar2){
            posx = (xbar1 + (xbar1-xbar2)/2)+15
        }
        if((ybar2-ybar1) === 0){
            posy = heigth - ybar1 - 60
        }
        ctx.font = "17px Arial";
        ctx.fillText(`Barra ${i+1}`, posx, posy)
        if(distributedMagnitudeX[i] !== 0 || distributedMagnitudeY[i] !== 0){
            ctx.fillText(`Fx: ${distributedMagnitudeX[i]} kN/m`, posx, posy+25)  
            ctx.fillText(`Fy: ${distributedMagnitudeY[i]} kN/m`, posx, posy+50)  
        }
    }
}